/**
 * This page is shown when the user's browser is not supported.
 * Supported browsers are based on browserlist from `package.json`.
 * User's browser is checked in middleware `/src/middleware.ts`,
 * if it is not supported, the user is redirected to this page.
 */
export default function UnsupportedBrowser() {
  return (
    <div
      style={{
        fontFamily: 'Lato',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '95vh', // Account for default margin on body
        overflow: 'hidden',
      }}
    >
      <h1>You browser is outdated.</h1>
      <p>
        To access the Faros app, please try updating your browser or switching
        to one of the following: Google Chrome, Mozilla Firefox, Microsoft Edge,
        Apple Safari, or Opera.
      </p>
    </div>
  )
}
